import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-looking-for',
  templateUrl: './looking-for.component.html',
  styleUrls: ['./looking-for.component.css']
})
export class LookingForComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
